// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__yoO-d","savePackageButton":"ClientWallet_savePackageButton__3_LCk"};